<template>
  <div>
    <loading :show="showProcessing" label="Processing"/>
    <overview-layout ref="overview" :tableCfg="tableCfg">
        <template slot="AdvancedFilter">
          <b-form ref="form" class="offset-md-1" autocomplete="off">
            <div class="row">
              <detail-field class="col-md-6" label="Intake" field="intake" :optionListApiUrl="'/contracts_intake/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
              <detail-field class="col-md-6" label="Type" field="scholarship_type" :optionListApiUrl="'/scholarships_type/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            </div>
          </b-form>
        </template>
    </overview-layout>
  </div>
</template>

<script>
import OverviewMixin from '../../components/OverviewMixin'
import loading from 'vue-full-loading'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'studentfee_overview',
  mixins: [OverviewMixin],
  components: {
    loading
  },
  data () {
    return {
      tableCfg: FieldDefs,
      showProcessing: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?33cb4b38